import { GridColDef, GridValueFormatterParams } from "@mui/x-data-grid";
import moment from "moment";

export const FEATURES = {
  FIRMWARE: 'firmware',
  TUNE: 'tune',
  OPTIONS: 'options',
  USERS: 'users',
};

export const FORM_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
};

export const FIRMWARE_BUTTON_IDS = {
  CREATE_BTN: 'create-frimware-btn',
  DOWNOLOAD_BTN: 'download-firmware-btn',
  UPLOAD_BTN: 'upload-firmware-btn',
  SUBMIT_BTN: 'submit-firmware-btn',
  CANCEL_BTN: 'cancel-firmware-btn',
  SAVE_BTN: 'save-firmware-btn',
  EDIT_BTN: 'edit-firmware-btn',
  DELETE_BTN: 'delete-firmware-btn',
};

export const TUNE_BUTTON_IDS = {
  CREATE_BTN: 'create-tune-btn',
  UPLOAD_BTN: 'upload-tune-btn',
  SUBMIT_BTN: 'submit-tune-btn',
  CANCEL_BTN: 'cancel-tune-btn',
  SAVE_BTN: 'save-tune-btn',
  EDIT_BTN: 'edit-tune-btn',
  DELETE_BTN: 'delete-tune-btn',
};

export const ROLES: string[] = [
  'admin',
  'affiliate',
  'elevated',
  'customer'
];

export const ROLE = {
  admin: 'admin',
  affiliate: 'affiliate',
  elevated: 'elevated',
  customer: 'customer',
}

export type RoleSelection = {
  name: string;
  selected: boolean;
}

export const COMPONENTS: string[] = [
  'LiveSB_Handlebar_Switch',
  'LiveSB_Bump_Sensor',
  'live-NEO'
];

export const FIRMWARE_TABLE_COLUMNS: GridColDef[] = [
  {
    field: 'componentId',
    headerName: 'Component Id',
    flex: 1,
    headerClassName: 'table-header',
  },
  {
    field: 'version',
    headerName: 'Version',
    flex: 1,
    headerClassName: 'table-header',
  },
  {
    field: 'size',
    headerName: 'Size (KiB)',
    flex: 1,
    headerClassName: 'table-header',
  },
  {
    field: 'createdAt',
    headerName: 'CreatedAt',
    flex: 1,
    headerClassName: 'table-header',
    valueFormatter: (params: GridValueFormatterParams<string>) => {
      if (!params.value) return '';

      return moment(params.value).format('YYYY-MM-DD')
    }
  },
  {
    field: 'ModifiedAt',
    headerName: 'ModifiedAt',
    flex: 1,
    headerClassName: 'table-header',
    valueFormatter: (params: GridValueFormatterParams<string>) => {
      if (!params.value) return '';

      return moment(params.value).format('YYYY-MM-DD')
    }
  },
  {
    field: 'authorizedRoles',
    headerName: 'Authorized Roles',
    flex: 1,
    headerClassName: 'table-header',
  },
  {
    field: 'authorizedUsers',
    headerName: 'Authorized Users',
    flex: 1,
    headerClassName: 'table-header',
    valueGetter: (params: any) => {
      return params.row.authorizedUserNames
    }
  },
];

export const TUNE_TABLE_COLUMNS: GridColDef[] = [
  {
    field: 'componentId',
    headerName: 'Component Id',
    flex: 1,
    headerClassName: 'table-header',
  },
  {
    field: 'userId',
    headerName: 'User Id',
    flex: 1,
    headerClassName: 'table-header',
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 1,
    headerClassName: 'table-header',
  },
  {
    field: 'authorizedRoles',
    headerName: 'Authorized Roles',
    flex: 1,
    headerClassName: 'table-header',
  },
  {
    field: 'authorizedUsers',
    headerName: 'Authorized Users',
    flex: 1,
    headerClassName: 'table-header',
    valueGetter: (params: any) => {
      return params.row.authorizedUserNames
    }
  },
];

export const USER_TABLE_COLUMNS: GridColDef[] = [
  {
    field: 'firstName',
    headerName: 'First Name',
    flex: 1,
    headerClassName: 'table-header'
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    flex: 1,
    headerClassName: 'table-header'
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    headerClassName: 'table-header'
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
    headerClassName: 'table-header'
  },
  {
    field: 'role',
    headerName: 'Role',
    flex: 1,
    headerClassName: 'table-header'
  },
  {
    field: 'phone',
    headerName: 'Phone',
    flex: 1,
    headerClassName: 'table-header'
  },
  {
    field: 'riderType',
    headerName: 'Rider Type',
    flex: 1,
    headerClassName: 'table-header'
  },
  {
    field: 'location',
    headerName: 'Location',
    description: 'This column can have lat long values, and is NOT sortable.',
    sortable: false,
    flex: 1,
    headerClassName: 'table-header'
  },
];

export const PAGE_SIZE = 10;
